const valetHelpUrlEn = 'http://help.cidirectinvesting.com/';
const valetHelpUrlFr = 'http://help.cidirectinvesting.com/fr_FR/';

export { valetHelpUrlEn, valetHelpUrlFr };
